import { render, staticRenderFns } from "./ShopContent.vue?vue&type=template&id=4c933d9a"
import script from "./ShopContent.vue?vue&type=script&lang=ts"
export * from "./ShopContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports